module.exports = __webpack_public_path__ + "img/爱奇艺_03.9c75b2f6.jpg";